import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import React, { useState, useEffect } from "react";
import { TimesheetEntry } from "../../core/types";
import { createSampleData } from "../../utils/sample-data";
import { startOfMonth, endOfMonth } from "date-fns";

interface Props {
  selectedDate: Date;
  onCreateEntries(entries: TimesheetEntry[]): void;
  onClear(): void;
}

const Debugger: React.FC<Props> = props => {
  const { onCreateEntries, selectedDate, onClear } = props;

  const [show, setShow] = useState(false);

  useEffect(() => {
    function onHashChange() {
      setShow(window.location.hash?.includes("debug"));
    }

    onHashChange();
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return show ? (
    <Modal isOpen>
      <ModalHeader>Debugger</ModalHeader>
      <ModalBody>
        <p>
          <Button
            onClick={() =>
              onCreateEntries(
                createSampleData([
                  startOfMonth(selectedDate),
                  endOfMonth(selectedDate)
                ])
              )
            }
          >
            Generate Sample Data
          </Button>
        </p>
        <p>
          <Button onClick={onClear}>Clear All Entries</Button>
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="link" onClick={() => (window.location.hash = "")}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  ) : null;
};

export default Debugger;
